import { bindable } from 'aurelia-framework';

export class ImportTypeSelect {
	@bindable importType: string;
	@bindable change: (params: any) => void;

	changeType(type: string) {
		this.importType = type;
		if (this.change) {
			this.change({ type });
		}
	}

	handleKeydown(event, type: string) {
		// Check if the pressed key is Enter or Space
		if (event.key === 'Enter' || event.key === ' ') {
			// Prevent the default action to stop scrolling when space is pressed
			event.preventDefault();
			this.changeType(type);
		} else {
			return true;
		}
	}
}
